export default __webpack_public_path__ + "media/184976fb9dbd253679e60d5fe7ecb371284151dd35f7d5d6cfdde7e7b13db0e1.svg";